module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_7_m.2d308734669eff95b574ec1d4888831b.png";